export const skuMapSelector = state => state.skuMap;
